import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error('Error caught:', error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', padding:'20px', fontFamily:'Tajawal,sans-serif', direction:'rtl', background:'#f5f5f5' }}>
          <div style={{ textAlign:'center', background:'#fff', padding:'40px', borderRadius:'16px', boxShadow:'0 4px 20px rgba(0,0,0,0.08)', maxWidth:'500px' }}>
            <div style={{ fontSize:'64px', marginBottom:'16px' }}>⚠️</div>
            <h2 style={{ color:'#c8531a', marginBottom:'12px' }}>حدث خطأ غير متوقع</h2>
            <p style={{ color:'#666', marginBottom:'20px', fontSize:'14px' }}>نعتذر عن الإزعاج، حاول تحديث الصفحة</p>
            <button onClick={() => { window.location.hash = ''; window.location.reload(); }}
              style={{ padding:'12px 32px', background:'#c8531a', color:'#fff', border:'none', borderRadius:'10px', fontSize:'15px', fontWeight:700, cursor:'pointer', marginRight:'8px' }}>
              🔄 تحديث الصفحة
            </button>
            {this.state.error && (
              <details style={{ marginTop:'20px', textAlign:'right', color:'#999', fontSize:'12px' }}>
                <summary style={{ cursor:'pointer' }}>تفاصيل الخطأ</summary>
                <pre style={{ overflow:'auto', background:'#f9f9f9', padding:'10px', borderRadius:'6px', marginTop:'8px', fontSize:'11px' }}>{String(this.state.error?.message || this.state.error)}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
